<details-section title="Persona Information" [showDetails]="false">
  <div *ngIf="form" class="details-layout" [formGroup]="form">
    <div class="form-content">
      <div class="top-row">
        <qai-field label="Avatar *">
          <qai-floating-select
            *ngIf="isReady"
            [options]="
              avatarReplicasSelectOptions ? avatarReplicasSelectOptions : []
            "
            [placeholder]="'Select Avatar'"
            [placement]="'below-start'"
            [offset]="4"
            [shape]="'rectangle'"
            [startIcon]="'search'"
            [value]="selectedAvatar"
            (selectionChange)="avatarReplicaSelectionChange($event)"
            [disabled]="readOnly || isUploadingBackground || isDeletingBackground"
          ></qai-floating-select>

          <qai-floating-select
            *ngIf="!isReady"
            [options]="
              avatarReplicasSelectOptions ? avatarReplicasSelectOptions : []
            "
            [placeholder]="'Select Avatar'"
            [placement]="'below-start'"
            [offset]="4"
            [shape]="'rectangle'"
            [startIcon]="'search'"
            [disabled]="readOnly || isUploadingBackground || isDeletingBackground"
            (selectionChange)="avatarReplicaSelectionChange($event)"
          ></qai-floating-select>
        </qai-field>

        <qai-field label="Name *"
          ><input qai-input type="text" formControlName="personaName"
        /></qai-field>
      </div>
      <div class="section-wrapper">
        <qai-field
          label="Initial greetings *"
          [description]="initialGreetingDescription"
        >
          <div class="message-wrapper" formArrayName="welcomeMessage">
            <div
              class="message-controls"
              *ngFor="let ctrl of welcomeMessageControls; let i = index"
            >
              <input qai-input qaiTrimLeading type="text" [formControlName]="i" />
              <button *ngIf="i > 0" (click)="removeGreetingOption(i)" [disabled]="readOnly" class="icon-button">
                <qai-icon kind="trash" positionStart></qai-icon>
              </button>
            </div>
          </div>
        </qai-field>
        <button
          *ngIf="welcomeMessageArray.length < 5"
          qai-button
          [shape]="'normal'"
          [kind]="'tertiary'"
          [size]="'medium'"
          (click)="addGreetingOption()"
          [disabled]="isAddGreetingDisabled || readOnly"
          class="message-button"
        >
          Add greeting option
        </button>
      </div>

      <div class="section-wrapper">
        <qai-field
          label="Resume message"
          [description]="resumeMessageDescription"
        >
          <div class="message-wrapper" formArrayName="resumeMessage">
            <div
              class="message-controls"
              *ngFor="let ctrl of resumeMessageControls; let i = index"
            >
              <input qai-input qaiTrimLeading type="text" [formControlName]="i" />
          
              <button
                *ngIf="i > 0"
                (click)="removeResumeMessage(i)"
                [disabled]="readOnly"
                class="icon-button"
              >
                <qai-icon kind="trash" positionStart></qai-icon>
              </button>
            </div>
          </div>
        </qai-field>
        <button
          *ngIf="resumeMessageArray.length < 5"
          qai-button
          [shape]="'normal'"
          [kind]="'tertiary'"
          [size]="'medium'"
          (click)="addResumeMessage()"
          [disabled]="isAddResumeMessageDisabled || readOnly"
          class="message-button"
        >
          Add message option
        </button>
      </div>
    </div>

    <div class="avatar-image">
      <div
        *ngIf="isUploadingBackground || isDeletingBackground"
        class="processing-placeholder"
      >
        <qai-loading [size]="'medium'"></qai-loading>
        <p class="loading-text">{{ isUploadingBackground ? 'Uploading...' : 'Deleting...' }}</p>
      </div>
      <img
        *ngIf="!selectedAvatarThumbnail && !avatarReplicaSelected && !uploadedBackgroundImage && !isUploadingBackground && !isDeletingBackground"
        src="/assets/img/simulation-images/simulation-avatar.svg"
        alt="Avatar"
        class="placeholder-image"
      />

      <img
        *ngIf="!avatarReplicaSelected && uploadedBackgroundImage && !isUploadingBackground && !isDeletingBackground && showAvatarCustomThumbnail"
        [noCacheSrc]="uploadedBackgroundImage"
        alt="Custom Background Preview"
        class="preview-image"
      />

      <img
        *ngIf="selectedAvatarThumbnail && !uploadedBackgroundImage && !isUploadingBackground && !isDeletingBackground && showAvatarCustomThumbnail"
        [noCacheSrc]="selectedAvatarThumbnail"
        alt="Avatar Thumbnail"
        class="avatar-thumbnail"
      />

      <img
        *ngIf="avatarReplicaSelected && uploadedBackgroundImage && processedImageDataUrl && !isUploadingBackground && !isDeletingBackground && showAvatarCustomThumbnail"
        [noCacheSrc]="processedImageDataUrl"
        alt="Avatar with custom background"
        class="processed-avatar-image"
      />

      <video
        *ngIf="avatarReplicaSelected && !uploadedBackgroundImage && !showAvatarCustomThumbnail"
        [src]="avatarReplicaSelected"
        muted
        controls
        disablePictureInPicture
        [attr.controlsList]="
          'nodownload noplaybackrate nopictureinpicture'
        "
        preload="auto"
        [attr.playsinline]="true"
        [attr.webkit-playsinline]="true"
      ></video>
      
      <div
        *ngIf="avatarReplicaSelected && uploadedBackgroundImage && !processedImageDataUrl && !isUploadingBackground && !isDeletingBackground && showAvatarCustomThumbnail"
        class="processing-placeholder"
      >
        <qai-loading [size]="'medium'"></qai-loading>
        <p class="loading-text">Processing image...</p>
      </div> 
      <div class="custom-background-header" *ngIf="showAvatarCustomThumbnail">
        <span class="custom-background-label">Custom Background</span>

        <qai-label
          *ngIf="uploadedBackgroundImage && !isDeletingBackground && !isUploadingBackground"
          kind="secondary"
          [size]="'medium'"
          [weight]="'regular'"
          class="remove-background-label"
          (click)="removeCustomBackground()"
        >
          <qai-icon kind="trash" positionStart />
          Remove background
        </qai-label>
      </div>

      <qai-file-upload
        *ngIf="showFileUpload && showAvatarCustomThumbnail"
        [acceptedFileTypes]="'image/png, image/jpeg'"
        [maxSizeInMB]="2"
        [disabled]="isUploadingBackground || isDeletingBackground || readOnly"
        (fileSelected)="onFileSelected($event)"
        (fileDropped)="onFileDropped($event)"
        [acceptedAspectRatio]="'16:9'"
        [aspectRatioTolerance]="0.01"
      >
        <div class="upload-content">
          <p class="upload-title">
            <span class="upload-link" [class.disabled]="isUploadingBackground || isDeletingBackground || readOnly">{{ uploadedBackgroundImage ? 'Click to replace' : 'Click to upload' }}</span>
            <span class="upload-text"> or drag and drop</span>
          </p>
          <p class="upload-description">
            PNG or JPG, 16:9 aspect ratio preferred, max. 2MB
          </p>
        </div>
      </qai-file-upload>

      <div *ngIf="uploadError && showAvatarCustomThumbnail" class="error-message upload-error">
        <qai-icon kind="alert-circle" />
        <span>{{ uploadError }}</span>
      </div>

      <div *ngIf="deleteError && showAvatarCustomThumbnail" class="error-message delete-error">
        <qai-icon kind="alert-circle" />
        <span>{{ deleteError }}</span>
      </div>
    </div>
  </div>
</details-section>
